import { selectContentForLanguage } from "@/lib/select-content-for-language"

type LanguageTranslation = {
  readonly language: string
  readonly name: string
}

export const selectTranslationNameForLanguage = (
  language: string,
  translations: ReadonlyArray<LanguageTranslation>,
): string =>
  selectContentForLanguage(
    language.toLowerCase(),
    Object.fromEntries(translations.map((translation) => [translation.language.toLowerCase(), translation.name])),
  )
